module.exports = __webpack_public_path__ + "static/media/inter-bold.79260e5b.woff";